import React, { useMemo } from 'react';
import FTLStopHelpers from '@/utilities/FTLStopHelpers';

export const useStopsAway = (route, order) => {
    return useMemo(() => {
        if (!route) return null;

        const stopSequence = route.stopsByRouteId
            .filter((stop) => FTLStopHelpers.isCustomerStop(stop, route))
            .sort((a, b) => a.ordering - b.ordering);

        const currOrderStopIdx = stopSequence.findIndex((stop) => {
            return (
                (stop.type === 'PICKUP' && stop.returns?.includes(order.order_id)) ||
                (stop.type === 'DROPOFF' && stop.orders?.includes(order.order_id) && !stop?.returns?.length)
            );
        });

        if (currOrderStopIdx < 0) return null;
        if (stopSequence[currOrderStopIdx]?.stop_completion_time) return;

        return stopSequence.slice(0, currOrderStopIdx).filter((stop) => !stop.stop_completion_time).length;
    }, [route, order]);
};
